import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { isDebug as isRoadmapDebug, dbg as roadmapDbg } from "./lib/dbg";

if (isRoadmapDebug()) {
  window.addEventListener("error", (e) => {
    roadmapDbg.error(
      "[RoadmapGlobalError]",
      e.error?.message || e.message || e,
    );
  });
  window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
    roadmapDbg.error("[RoadmapGlobalRejection]", (e as any)?.reason || e);
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
